import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtCell } from "@/lib/exporters";
import { cn } from "@/lib/utils";

const NUMERIC = ["money", "int", "qty", "pct"];

function Summary({ items }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="report-summary">
      {items.map((s, i) => (
        <div key={s.label} className="card-surface p-4 fade-up" style={{ animationDelay: `${i * 40}ms` }} data-testid={`report-summary-${i}`}>
          <p className="eyebrow">{s.label}</p>
          <p className="mt-2 font-display text-xl font-bold tracking-tight truncate">{s.fmt === "text" ? s.value : fmtCell(s.value, s.fmt) || "0"}</p>
        </div>
      ))}
    </div>
  );
}

function Chart({ data, fmt }) {
  return (
    <div className="card-surface p-5" data-testid="report-chart">
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }} tickLine={false} axisLine={false} />
            <YAxis tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }} tickLine={false} axisLine={false} width={52} />
            <Tooltip formatter={(v) => fmtCell(v, fmt || "money")} cursor={{ fill: "hsl(var(--accent))" }} />
            <Bar dataKey="value" fill="hsl(var(--primary))" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export function ReportView({ report }) {
  return (
    <div className="space-y-4">
      <Summary items={report.summary} />
      {report.chart?.length > 1 && <Chart data={report.chart} fmt={report.chart_fmt} />}
      {report.note && <p className="text-xs text-muted-foreground" data-testid="report-note">{report.note}</p>}
      <div className="card-surface overflow-x-auto">
        <Table data-testid="report-table">
          <TableHeader>
            <TableRow>{report.columns.map((c) => <TableHead key={c.key} className={cn("whitespace-nowrap", NUMERIC.includes(c.fmt) && "text-right")}>{c.label}</TableHead>)}</TableRow>
          </TableHeader>
          <TableBody>
            {report.rows.map((r, i) => (
              <TableRow key={i} data-testid={`report-row-${i}`}>
                {report.columns.map((c) => <TableCell key={c.key} className={cn("whitespace-nowrap", NUMERIC.includes(c.fmt) && "text-right font-mono")}>{fmtCell(r[c.key], c.fmt)}</TableCell>)}
              </TableRow>
            ))}
            {!report.rows.length && <TableRow><TableCell colSpan={report.columns.length} className="py-10 text-center text-muted-foreground" data-testid="report-empty">Nenhum dado encontrado para os filtros escolhidos.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
      {report.truncated && <p className="text-xs text-muted-foreground">Mostrando as primeiras 5.000 linhas. Reduza o período para ver tudo.</p>}
    </div>
  );
}
